var _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaymentInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 17702",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13092",
    d: "M17 21a5 5 0 01-5-5 5.078 5.078 0 015.005-5A5 5 0 0117 21"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13093",
    d: "M2 6.85h19"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13094",
    d: "M21 13V5a2 2 0 00-2-2H4a2 2 0 00-2 2v9a2 2 0 002 2h8"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13095",
    d: "M19.222 14.889l-2.778 2.778L14.778 16"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13096",
    d: "M0 0h24v24H0z",
    fill: "none"
  })));
}
export default SvgPaymentInfo;


//////////////////
// WEBPACK FOOTER
// ./src/components/Quoters/AmericoLoanProtection/icons/paymentInfo.svg
// module id = 8152
// module chunks = 11